// removed by extract-text-webpack-plugin
module.exports = {"Upload":"_3z02AtDHIaXPVkFGTw6ydq","BlockImage":"_2DnlmL1uW-ICDV7qQrDXGM","BlockInfo":"_3DODzttMb4UMoU34FeSxu4","Table":"_2u_uN9k8rOc_2xuBazMwA-","Error":"_2qjTuPpcH9vVh8WArooPgH","Success":"_3PLBiAxiT1mVtwyT1n16p5","ErrorsList":"_3dtubgA82cCHQ9antG4Ovb","ErrorsTitle":"_1E54t9EjOmaA9_-08-v0NS","ErrorsHelp":"_2UWemiCg8IPp1DDROz6Ni4","ErrorsHelpTitle":"_383kORumPAcp0Ff859PYji"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/RegistryUploadInfo/styles.module.css
// module id = 576
// module chunks = 0